/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sources: NonNullable<unknown> }} Meeting_Report_SourcesInputs */



/**
* | output |
* | --- |
* | "Sources: {sources}" |
*
* @param {Meeting_Report_SourcesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_sources = /** @type {((inputs: Meeting_Report_SourcesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_SourcesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Bronnen: ${i?.sources}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Sources : ${i?.sources}`)
	return /** @type {LocalizedString} */ (`Sources: ${i?.sources}`)
});